/* eslint-disable import/no-dynamic-require */
<template>
	<img :alt="iconName" :src="src" class="table-row-icon"
		:class="{'table': tableAction, 'custom-icon-small': small, 'custom-icon-large': !small}">
</template>
<script>
export default {
	name: 'DmsCustomIcon',
	props: {
		iconName: {
			type: String,
			require,
		},
		customPath: {
			type: String,
		},
		small: {
			type: Boolean,
			default: true,
		},
		tableAction: {
			type: Boolean,
			default: false,
		},
		format: {
			type: String,
			default: 'svg',
		},
	},
	computed: {

		src() {
			if (this.customPath) {
				/* eslint-disable-next-line */
				return require(`${this.customPath}.${this.format}`);
			}
			/* eslint-disable-next-line */
			return require(`@/assets/icons/${this.iconName}.${this.format}`);
		},
	},
};
</script>
<style scoped lang="scss">
.table {
    @at-root p#{&} {
        margin-left: 8px;
    }
}
.custom-icon-small {
  width: 10px;
}
.custom-icon-large {
  width: 14px;
}
</style>
